module.exports = __webpack_public_path__ + "img/8.8ab6b6c4.jpg";